// ============================================================================
// Index portal entry. Imports track configs (no module bodies needed — we
// only render label + storage key + moduleOrder.length on this page), then
// hands them to <index-portal>.
// ============================================================================

import './styles/brand.css';
import './portal/index-portal.js';
import type { IndexPortal, RoleCard } from './portal/index-portal.js';

import { trackConfigSchema } from './engine/schema.js';
import type { TrackConfig } from './engine/index.js';

import maintenanceConfig from './tracks/maintenance/config.json';
import groundopsConfig from './tracks/groundops/config.json';

function lightTrack(rawConfig: unknown): TrackConfig {
  const parsed = trackConfigSchema.parse(rawConfig);
  // The portal doesn't need module bodies — empty modules + comingSoon
  // satisfies the type without pulling in any content JSON.
  return { ...parsed, modules: {}, comingSoon: {} };
}

const maintenance = lightTrack(maintenanceConfig);
const groundops   = lightTrack(groundopsConfig);

const cards: RoleCard[] = [
  {
    id: 'maintenance',
    title: 'Maintenance Engineers',
    description:
      'LAME, apprentice, and quality staff. CASR Part 145 human factors programme — Dirty Dozen, SHELL model, structured handover, TEM and safety culture.',
    href: 'maintenance.html',
    track: maintenance,
    status: 'active',
  },
  {
    id: 'pilots',
    title: 'Pilots',
    description:
      'Fixed wing and rotary flight crew. CRM, threat & error management, Endsley situational awareness model, FOR-DEC decision making, fatigue management.',
    status: 'coming_soon',
  },
  {
    id: 'cabin-medical',
    title: 'Cabin Crew & Medical Transport',
    description:
      'Cabin attendants and aeromedical staff. SBAR communication, patient handover, TEM in aeromedical contexts, workload management during medical events.',
    status: 'coming_soon',
  },
  {
    id: 'groundops',
    title: 'Ground Staff & Operations',
    description:
      'Ramp, FBO, and operations personnel. IATA IGOM · IS-BAH human factors programme — airside safety, FOD, ground handling, fuel handling, cargo & DG, emergency response.',
    href: 'groundops.html',
    track: groundops,
    status: 'active',
  },
];

const portal = (document.querySelector('index-portal') ?? appendDefault()) as IndexPortal;
portal.cards = cards;

function appendDefault(): IndexPortal {
  const el = document.createElement('index-portal');
  document.body.appendChild(el);
  return el;
}
